document.addEventListener('alpine:init', () => {
  Alpine.data('productCardMedia', (maxIndex = 0) => ({
    active: 0,
    frame: null,

    update() {
      if (this.frame !== null) return;

      const track = this.$refs.track;
      if (!track) return;

      this.frame = requestAnimationFrame(() => {
        this.frame = null;

        const width = track.clientWidth || 1;

        const nextActive = Math.max(
          0,
          Math.min(
            Number(maxIndex) || 0,
            Math.round(track.scrollLeft / width)
          )
        );

        if (nextActive !== this.active) {
          this.active = nextActive;
        }
      });
    },

    destroy() {
      if (this.frame === null) return;

      cancelAnimationFrame(this.frame);
      this.frame = null;
    }
  }));
});